import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	Box,
	List,
	Typography,
	Avatar,
	ListItem,
	FormControlLabel,
	Checkbox,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Tooltip,
	Link,
	Badge,
	Chip,
	Switch,
	TextField,
	InputAdornment,
	Popper,
	Paper,
	ClickAwayListener,
	MenuList,
	MenuItem,
	ListItemAvatar,
	ListItemText,
	Grow,
	Button,
	TablePagination
} from '@material-ui/core';
import { getMonthDate, getMonthDateYear, getUserDetails, getUserName } from '../../../config/utils';
import { getLocalStorageItem } from '../../../services/StorageService';
import {
	AcceptIcon,
	CrossIcon,
	DownloadIcon,
	NewFilterIcon,
	Perform360Icon,
	RecommendedIcon,
	ReconsiderIcon,
	ReportsTooltipIcon,
	SearchIcon,
	SortingIcon,
	TickIcon,
} from '../../../config/svg/CommonSvgIcon';
import { OKRButton } from '../../Common/OKRButton';
import { useTranslation } from 'react-i18next';
import { ConversationIcon, DirectReportReviewIcon, FinalAssessmentIcon } from '../../../config/svg/CommonSvg';
import { getOkrMasterData } from '../../../action/myGoal';
import {
	getTeamReviewUserList,
	getGoalAlertConversation,
	setPerformanceSelfReviewDrUserData,
	reviewApproveBulk,
	reviewReconsiderBulk,
} from '../../../action/adminSettings';
import { Enums } from '../../../config/enums';
import { TeamReviewStats } from './TeamReviewStats';
import { AnimatedIcon } from '../../Common/AnimatedIcon';
import YetToBeginImage from '../../../images/assessment-yet-to-begin.svg';
import { NoRecord } from '../../Admin/CommonComponent/NoRecord';
import NoDataImg from '../../../images/my-goal-bg.svg';
import LinearLoader from '../../Common/Loader';
import { ReviewConversationsSettings } from '../ReviewConversationsSettings';
import { HeaderTooltip } from '../../Reports/HeaderTooltip';
import { TeamReviewData } from './TeamReviewData';
import { BorderCheckboxIcon, CheckedIcon, UnCheckedIcon } from '../../../config/svg/formElementIcons';
import { DownArrowIcon, UpArrowIcon } from '../../../config/svg/ArrowSvg';
import { CancelIcon } from '../../../config/svg/Action';
import { TeamReviewFilterList } from '../../../config/constant';
import { setTeamReviewForRedirection } from '../../../action/common';
import { useSnackbar } from 'notistack';
import AlertDialog from '../../Common/Dialog';

export const TeamReview = (props: any) => {
	const { setImageList, imageList, uploadCase, activeStep, cycleData, drUserData, fromTeamDetails, fromApproval } =
		props;
	const { okrMasterData } = useSelector((state: any) => state?.okrReducer);
	const { t } = useTranslation();
	const dispatch = useDispatch();
	let userDetail = getUserDetails();
	const tenantData = JSON.parse(getLocalStorageItem('TenantData') || '{}');
	const { currentGoalReviewCycle } = useSelector((state: any) => state.adminSettingReducer);
	const [teamReviewUserListResponse, setTeamReviewUserListResponse] = useState<any>({});
	const [teamReviewUserList, setTeamReviewUserList] = useState<any>([]);
	const [reviewWorkFlowApprovalList, setReviewWorkFlowApprovalList] = useState<any>([]);
	const [teamsReviewHeaderResponse, setTeamsReviewHeaderResponse] = useState<any>(null);
	const [loader, setLoader] = useState<boolean>(false);
	const [searchValue, setSearchValue] = useState<string>('');
	const [searchTextArray, setSearchTextArray] = useState<string>('');
	const [isMyActionable, setIsMyActionable] = useState<boolean>(false);
	const [isPublished, setIsPublished] = useState<boolean>(false);
	const [performanceGoalReviewWorkFlowTypeId, setPerformanceGoalReviewWorkFlowTypeId] = useState<any>(0);
	const { enqueueSnackbar } = useSnackbar();
	const [sortingData, setSortingData] = useState<any>({ column: 'firstName', order: 'asc' });
	const [performanceGoalReviewCycleId, setPerformanceGoalReviewCycleId] = useState<number>(0);
	const [categorySettingsOpen, setCategorySettingsOpen] = useState<any>({ open: false });
	const [currentTab, setCurrentTab] = useState<string>('');
	const [openReviewApproval, setOpenReviewApproval] = useState<boolean>(false);
	const [anchorElReviewApproval, setAnchorElReviewApproval] = useState<HTMLElement | null>(null);

	const [openFilter, setOpenFilter] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [appliedFilter, setAppliedFilter] = useState<boolean>(false);
	const [localFilterCondition, setLocalFilterCondition] = useState<any>([]);
	const [finalFilterCondition, setFinalFilterCondition] = useState<any>([]);
	const [showBulkOption, setShowBulkOption] = useState(false);
	const [performanceGoalReviewWorkFlowTypeIdValue, setPerformanceGoalReviewWorkFlowTypeIdValue] = useState(0);
	const [allowOnlyWorkflowId, setAllowOnlyWorkflowId] = useState(0);
	const [checkedUser, setCheckedUser] = useState(0);
	const [isSelectAllPages, setIsSelectAllPages] = useState<boolean>(false);
	const [excludedIds, setExcludedIds] = useState<Set<number>>(new Set());
	const { redirectedTeamReviewDetails } = useSelector((state: any) => state.commonReducer);
	const [modalProps, setModalProps] = useState<any>({ open: false, type: '', message: '', details: '' });
	const [page, setPage] = useState<number>(0);
	const [rowsPerPage, setRowsPerPage] = useState<number>(10);
	const [totalCount, setTotalCount] = useState<number>(0);

	useEffect(() => {
		if (
			teamReviewUserList &&
			teamReviewUserList.length > 0 &&
			redirectedTeamReviewDetails &&
			redirectedTeamReviewDetails.performanceGoalCycleReviewId &&
			redirectedTeamReviewDetails.employeeId
		) {
			let selectedUser: any = {};
			if (redirectedTeamReviewDetails && redirectedTeamReviewDetails.employeeId) {
				selectedUser = teamReviewUserList.find(
					(item: any) => item.employeeId === redirectedTeamReviewDetails.employeeId
				);
			}
			dispatch(
				setPerformanceSelfReviewDrUserData({
					...redirectedTeamReviewDetails,
					firstName: redirectedTeamReviewDetails?.firstName
						? redirectedTeamReviewDetails?.firstName
						: selectedUser?.firstName,
					lastName: redirectedTeamReviewDetails?.lastName
						? redirectedTeamReviewDetails?.lastName
						: selectedUser?.lastName,
					imagePath: redirectedTeamReviewDetails?.imagePath
						? redirectedTeamReviewDetails?.imagePath
						: selectedUser?.imagePath,
					fromManager: true,
					fromApproval: redirectedTeamReviewDetails?.tabId === 3 ? true : false,
					teamReviewUserListResponse: { ...redirectedTeamReviewDetails, ...selectedUser },
					...selectedUser,
				})
			);
			dispatch(setTeamReviewForRedirection(null));
		}
	}, [teamReviewUserList, redirectedTeamReviewDetails]);
	useEffect(() => {
		window.scroll({ top: 0, left: 0, behavior: 'smooth' });
	}, []);
	useEffect(() => {
		if (currentGoalReviewCycle && currentGoalReviewCycle?.performanceGoalReviewCycleId) {
			let performanceGoalReviewCycleId =
				currentGoalReviewCycle && currentGoalReviewCycle.performanceGoalReviewCycleId
					? currentGoalReviewCycle.performanceGoalReviewCycleId
					: 0;

			setPerformanceGoalReviewCycleId(performanceGoalReviewCycleId);
			let requestParam: any = {
				performanceGoalReviewCycleId: performanceGoalReviewCycleId,
				sortingText: sortingData.column,
				order: sortingData.order,
				finder: searchTextArray,
				isMyActionable: isMyActionable,
				performanceGoalReviewWorkFlowTypeId: performanceGoalReviewWorkFlowTypeId,
				isPublished: isPublished,
				filterList: finalFilterCondition && finalFilterCondition.map((item: any) => item.subCategoryId),
				IsReviewApproval: fromApproval ? true : false,
				page: page + 1,
				pageSize: rowsPerPage,
			};
			getTeamReviewUserListDetails(requestParam);
		}
	}, [
		currentGoalReviewCycle,
		searchTextArray,
		isMyActionable,
		performanceGoalReviewWorkFlowTypeId,
		isPublished,
		finalFilterCondition,
		page,
		rowsPerPage,
	]);

	const reloadList = () => {
		let requestParam: any = {
			performanceGoalReviewCycleId: performanceGoalReviewCycleId,
			sortingText: sortingData.column,
			order: sortingData.order,
			finder: searchTextArray,
			isMyActionable: isMyActionable,
			performanceGoalReviewWorkFlowTypeId: performanceGoalReviewWorkFlowTypeId,
			isPublished: isPublished,
			filterList: finalFilterCondition && finalFilterCondition.map((item: any) => item.subCategoryId),
			IsReviewApproval: fromApproval ? true : false,
			page: page + 1,
			pageSize: rowsPerPage,
		};
		setCheckedUser(0);
		setShowBulkOption(false);
		setIsSelectAllPages(false);
		setPage(0);
		setExcludedIds(new Set());
		getTeamReviewUserListDetails(requestParam);
	};

	const handleToggleFilter = (event: any) => {
		setAnchorEl(event.currentTarget);
		setOpenFilter((prev) => !prev);
	};

	const handleClose = (event: any) => {
		setAnchorEl(null);
		setOpenFilter(false);
	};

	const clearFilter = () => {
		setLocalFilterCondition([]);
		setFinalFilterCondition([]);
	};

	const handleFilterChanged = (value: number) => {
		let filterData: any = [...localFilterCondition];
		let indexParent = filterData.indexOf(value);
		if (indexParent === -1) {
			filterData.push(value);
		} else {
			filterData.splice(indexParent, 1);
		}
		setLocalFilterCondition(filterData);
	};

	const handleCloseChip = (value: any) => {
		let filterData: any = [...localFilterCondition];
		let indexParent = filterData.indexOf(value.subCategoryId);
		if (indexParent !== -1) {
			filterData.splice(indexParent, 1);
		}
		setLocalFilterCondition(filterData);
		handleApplyFilterClick(filterData);
	};
	const handleApplyFilterClick = (filtersData: any) => {
		let filters: any = [];
		TeamReviewFilterList.map((category: any, index: number) => {
			category.subCategories.map((subCategory: any, index: number) => {
				if (filtersData && filtersData.indexOf(subCategory.subCategoryId) !== -1) {
					filters.push({
						...subCategory,
					});
				}
			});
		});
		setAppliedFilter(true);
		setFinalFilterCondition([...filters]);
		setPage(0);
	};

	const getTeamReviewUserListDetails = async (requestPayload: any) => {
		try {
			setLoader(true);
			const response: any = await dispatch(getTeamReviewUserList(requestPayload));
			if (response && response?.data?.status === Enums.STATUS_SUCCESS) {
				if (response?.data) {
					const { entity } = response.data;
					setTeamReviewUserListResponse(entity);
					const { reviewEmployeeDetailsResponse, reviewWorkFlowApprovalResponse, teamsReviewHeaderResponse } = entity;
					if (isSelectAllPages) {
						const updated = reviewEmployeeDetailsResponse.map((item: any) =>
							item.isCheckboxEnable && !excludedIds.has(item.performanceGoalRatingAssessmentId)
								? { ...item, isChecked: true }
								: item
						);
						setTeamReviewUserList(updated);
					} else {
						setTeamReviewUserList(reviewEmployeeDetailsResponse);
					}
					setReviewWorkFlowApprovalList(reviewWorkFlowApprovalResponse);
					setTeamsReviewHeaderResponse(teamsReviewHeaderResponse);
					// Set total count for pagination from server response
					setTotalCount(entity?.pagingInfo?.totalRecords || 0);
				} else {
					setTeamReviewUserListResponse(null);
					setTeamReviewUserList([]);
					setTotalCount(0);
				}
				setLoader(false);
			} else {
				setLoader(false);
			}
		} catch (error) {}
	};

	const sortList = (e: any, column: any) => {
		let newSortOrder = 'desc';
		if (column === sortingData.column) {
			newSortOrder = sortingData.order === 'asc' ? 'desc' : 'asc';
		}
		setSortingData({ column: column, order: newSortOrder });
		getTeamReviewUserListDetails({
			performanceGoalReviewCycleId: performanceGoalReviewCycleId,
			sortingText: column,
			order: newSortOrder,
			finder: searchTextArray,
			isMyActionable: isMyActionable,
			performanceGoalReviewWorkFlowTypeId: performanceGoalReviewWorkFlowTypeId,
			isPublished: isPublished,
			page: page + 1,
			pageSize: rowsPerPage,
		});
	};

	const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleHeaderFilter = (workFlowTypeId: any, published: boolean) => {
		setPerformanceGoalReviewWorkFlowTypeId(workFlowTypeId === performanceGoalReviewWorkFlowTypeId ? 0 : workFlowTypeId);
		setIsPublished(published && isPublished ? false : published);
		setPage(0);
	};

	const handleIsMyActionableOnly = (e: any) => {
		const { checked } = e?.target;
		setLoader(true);
		setIsMyActionable(checked);
		setPage(0);
	};

	const handleSearchChange = (e: any) => {
		setSearchValue(e.target.value);
	};

	const searchClicked = (e: any) => {
		if (e.key === 'Enter') {
			if (e.target.value && e.target.value.trim() !== '') {
				handleSearch(e.target.value);
			}
			setSearchValue('');
		}
	};

	const handleSearch = (value: any) => {
		setSearchTextArray(value);
		setLoader(true);
	};

	const clearSearch = () => {
		setSearchTextArray('');
	};

	const handleSettingsDrawerOpen = (event: any, usersDetails: any, tabToOpen?: string) => {
		setCategorySettingsOpen({ open: true, data: usersDetails });
		if (tabToOpen) {
			setCurrentTab(tabToOpen);
		}
	};

	const handleSettingsDrawerClose = (event: any) => {
		event.preventDefault();
		event.stopPropagation();
		setCategorySettingsOpen({ open: false, data: '' });
		if (currentTab === 'conversation') {
			//getUserPerformanceGoalsList();
			dispatch(getGoalAlertConversation());
		}
	};

	const handleReviewApprovalOpen = (event: any) => {
		setAnchorElReviewApproval(event.currentTarget);
		setOpenReviewApproval(true);
	};
	const handleReviewApprovalClose = () => {
		setOpenReviewApproval(false);
		setAnchorElReviewApproval(null);
	};

	const handleIndeterminate = () => {
		let findChecked = teamReviewUserList.filter((item: any) => item.isChecked);
		if (findChecked.length > 0 && findChecked.length !== teamReviewUserList.length) {
			return true;
		} else {
			return false;
		}
	};

	const handleAllChecked = () => {
		if (!teamReviewUserList || teamReviewUserList.length === 0) {
			return false;
		}
		// Only consider enabled checkboxes
		const enabledItems = teamReviewUserList.filter((item: any) => item.isCheckboxEnable);
		if (enabledItems.length === 0) {
			return false;
		}
		// Check if all enabled items are checked
		const allEnabledChecked = enabledItems.every((item: any) => item.isChecked === true);
		return allEnabledChecked;
	};

	const onSelectAllClick = (e: any) => {
		const checked = e.target.checked;

		if (checked) {
			setIsSelectAllPages(true);
			setExcludedIds(new Set());
			const updated = teamReviewUserList.map((item: any) =>
				item.isCheckboxEnable ? { ...item, isChecked: true } : item
			);
			setTeamReviewUserList(updated);
			const enabledCount = updated.filter((u: any) => u.isCheckboxEnable).length;
			setCheckedUser(totalCount);
			if (enabledCount > 0) {
				setShowBulkOption(true);
				const first = updated.find((u: any) => u.isChecked && u.isCheckboxEnable);
				if (first) {
					setPerformanceGoalReviewWorkFlowTypeIdValue(first.performanceGoalReviewWorkFlowTypeId);
					setAllowOnlyWorkflowId(first.performanceGoalReviewWorkFlowTypeId);
				}
			} else {
				setShowBulkOption(true);
			}
		} else {
			setIsSelectAllPages(false);
			setExcludedIds(new Set());
			const updated = teamReviewUserList.map((item: any) => ({ ...item, isChecked: false }));
			setTeamReviewUserList(updated);
			setCheckedUser(0);
			setShowBulkOption(false);
			setAllowOnlyWorkflowId(0);
			setPerformanceGoalReviewWorkFlowTypeIdValue(0);
		}
	};

	const onUserSelect = (e: any, index: number) => {
		const { checked } = e.target;
		const updateCheck = [...teamReviewUserList];
		const item = updateCheck[index];
		if (allowOnlyWorkflowId === 0 || allowOnlyWorkflowId === item.performanceGoalReviewWorkFlowTypeId) {
			updateCheck[index] = { ...item, isChecked: checked };
			setTeamReviewUserList(updateCheck);

			if (isSelectAllPages) {
				const newExcluded = new Set(excludedIds);
				if (checked) {
					newExcluded.delete(item.performanceGoalRatingAssessmentId);
				} else {
					newExcluded.add(item.performanceGoalRatingAssessmentId);
				}
				setExcludedIds(newExcluded);
				const newCount = totalCount - newExcluded.size;
				setCheckedUser(newCount);
				if (newCount === 0) {
					setIsSelectAllPages(false);
					setExcludedIds(new Set());
					setShowBulkOption(false);
					setAllowOnlyWorkflowId(0);
				}
			} else {
				const findChecked = updateCheck.filter((u: any) => u.isChecked).length;
				setCheckedUser(findChecked);
				if (findChecked > 0) {
					setPerformanceGoalReviewWorkFlowTypeIdValue(item.performanceGoalReviewWorkFlowTypeId);
					setAllowOnlyWorkflowId(item.performanceGoalReviewWorkFlowTypeId);
					setShowBulkOption(true);
				} else {
					setShowBulkOption(false);
					setAllowOnlyWorkflowId(0);
				}
			}
		}
	};
	const getSelectedUsers = async () => {
		if (isSelectAllPages) {
			const requestParam = {
				performanceGoalReviewCycleId,
				sortingText: sortingData.column,
				order: sortingData.order,
				finder: searchTextArray,
				isMyActionable,
				performanceGoalReviewWorkFlowTypeId,
				isPublished,
				filterList: finalFilterCondition?.map((item: any) => item.subCategoryId),
				IsReviewApproval: fromApproval ? true : false,
				page: 1,
				pageSize: totalCount,
			};
			const response: any = await dispatch(getTeamReviewUserList(requestParam));
			if (response?.data?.status === Enums.STATUS_SUCCESS) {
				const all = response.data.entity?.reviewEmployeeDetailsResponse || [];
				return all
					.filter((item: any) => item.isCheckboxEnable && !excludedIds.has(item.performanceGoalRatingAssessmentId))
					.map((item: any) => ({
						performanceGoalRatingAssessmentId: item.performanceGoalRatingAssessmentId,
						performanceGoalReviewWorkFlowTypeId: item.performanceGoalReviewWorkFlowTypeId,
					}));
			}
			return [];
		}
		return teamReviewUserList
			.filter((item: any) => item.isChecked)
			.map((item: any) => ({
				performanceGoalRatingAssessmentId: item.performanceGoalRatingAssessmentId,
				performanceGoalReviewWorkFlowTypeId: item.performanceGoalReviewWorkFlowTypeId,
			}));
	};
	const handleMultipleApprove = async () => {
		let selectedUser: any = await getSelectedUsers();
		if (selectedUser?.length === 0) {
			return false;
		}
		setLoader(true);
		const response: any = await dispatch(reviewApproveBulk(selectedUser));
		if (response && response?.data?.status === Enums.STATUS_SUCCESS) {
			const { messageList } = response.data;
			const keys = Object.keys(messageList);
			const messages = keys.map((item) => messageList[item]);
			enqueueSnackbar(messages || 'Approved successfully', {
				variant: 'success',
				autoHideDuration: 3000,
			});
			reloadList();
			setLoader(false);
		} else {
			setLoader(false);
		}
	};
	const handleMultipleReconsider = async () => {
		let selectedUser: any = await getSelectedUsers();
		if (selectedUser?.length === 0) {
			return false;
		}
		setLoader(true);
		const response: any = await dispatch(reviewReconsiderBulk(selectedUser));
		if (response && response?.data?.status === Enums.STATUS_SUCCESS) {
			const { messageList } = response.data;
			const keys = Object.keys(messageList);
			const messages = keys.map((item) => messageList[item]);
			enqueueSnackbar(messages || 'Sent for reconsider successfully', {
				variant: 'success',
				autoHideDuration: 3000,
			});
			reloadList();
			setLoader(false);
		} else {
			setLoader(false);
		}
	};

	const handleCloseModal = async (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			if (modalProps?.type === 'reconsider') {
				handleMultipleReconsider();
			} else if (modalProps?.type === 'approve') {
				handleMultipleApprove();
			}
		}
		setModalProps({ open: false, type: '', message: '', details: '' });
	};
	return (
		<>
			{loader && <LinearLoader />}

			{currentGoalReviewCycle === null ? (
				<Box className='welcome-content goals-review-welcome' id='performance-goals-welcome'>
					<Box textAlign='center' className='pad-container'>
						<Typography variant='h2'>{t('teamReviewYetToBeginTitle')}</Typography>
						<Typography>{t('teamReviewYetToBeginSubTitle')}</Typography>
						<AnimatedIcon
							className=''
							width='388'
							type='image/svg+xml'
							alt='WelcomeImage'
							imagePath={YetToBeginImage}
						/>
					</Box>
				</Box>
			) : teamReviewUserListResponse && !teamReviewUserListResponse.isUsersAssigned ? (
				<Box className='welcome-content goals-review-welcome' id='performance-goals-welcome'>
					<Box textAlign='center' className='pad-container'>
						{fromApproval ? (
							<>
								<Typography variant='h2'>{t('reveiwApprovalsNoDrTitle')}</Typography>
								<Typography>{t('reveiwApprovalsNoDrSubtitle')}</Typography>
							</>
						) : (
							<>
								<Typography variant='h2'>{t('teamReviewNoDRAssignedForThisCycleTitle')}</Typography>
								<Typography>{t('teamReviewNoDRAssignedForThisCycleSubTitle')}</Typography>
							</>
						)}

						<AnimatedIcon
							className=''
							width='388'
							type='image/svg+xml'
							alt='WelcomeImage'
							imagePath={YetToBeginImage}
						/>
					</Box>
				</Box>
			) : (
				<>
					<Box className='goals-review-stats-area' id='goals-team-review-stats-area'>
						<TeamReviewStats
							t={t}
							teamsReviewHeaderResponse={teamsReviewHeaderResponse}
							teamReviewUserListResponse={teamReviewUserListResponse}
							handleHeaderFilter={handleHeaderFilter}
							performanceGoalReviewWorkFlowTypeId={performanceGoalReviewWorkFlowTypeId}
							isPublished={isPublished}
						/>
					</Box>
					<Box className='goal-team-review-area'>
						<Box className='team-review-listing-header'>
							<Box className='team-review-listing-header-left'>
								<Box className='my-actionable-switch'>
									<FormControlLabel
										control={
											<Switch
												id='my-actionable'
												name='myActionable'
												checked={Boolean(isMyActionable)}
												onChange={handleIsMyActionableOnly}
												inputProps={{ 'aria-label': 'controlled' }}
											/>
										}
										label={`${t('myActionableLevel')} (${teamReviewUserListResponse.myActionableCount})`}
									/>
								</Box>
							</Box>
							<Box className='team-review-listing-header-right'>
								{teamReviewUserList && teamReviewUserList.length > 0 && (
									<TablePagination
										component='div'
										className='user-list-pagination lg-pagination'
										count={totalCount}
										page={page}
										onPageChange={handleChangePage}
										rowsPerPage={rowsPerPage}
										onRowsPerPageChange={handleChangeRowsPerPage}
										labelDisplayedRows={({ from, to, count }) =>
											`${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
										}
										SelectProps={{
											MenuProps: {
												PopoverClasses: { paper: 'okr-default-dropdown user-number-dropdown' },
											},
										}}
									/>
								)}
								<Box className='filter-list-dropdown'>
									<OKRButton
										className={`list-filter-btn ${openFilter ? 'active' : ''}`}
										icon={<NewFilterIcon />}
										text={
											<span className='filter-txt'>
												{t('filterLabel')}
												{openFilter ? <UpArrowIcon /> : <DownArrowIcon />}
											</span>
										}
										handleClick={handleToggleFilter}
										id='dashboard-filter-btn'
									/>
									<Box className={`filter-chip `}>
										{appliedFilter && (
											<List>
												{finalFilterCondition && finalFilterCondition.length > 0 ? (
													<>
														{finalFilterCondition.slice(0, 1).map((item: any, index: any) => (
															<ListItem key={index}>
																<Tooltip arrow title={item.subCategoryName}>
																	<Typography variant='body2'>{item.subCategoryName}</Typography>
																</Tooltip>
																<Button className='cancel-btn' onClick={() => handleCloseChip(item)}>
																	<CancelIcon />
																</Button>
															</ListItem>
														))}
														{finalFilterCondition.length > 1 && (
															<ListItem className='more-filter-count'>
																<Typography variant='body2'>+{finalFilterCondition.length - 1}</Typography>
															</ListItem>
														)}

														<ListItem className='clear-all'>
															<Link onClick={clearFilter}>{t('clearAll')}</Link>
														</ListItem>
													</>
												) : (
													<></>
												)}
											</List>
										)}
									</Box>
									<Popper
										className={`filter-list-popup`}
										open={openFilter}
										anchorEl={anchorEl}
										id='filtersPopper'
										placement={'bottom-start'}
										modifiers={{
											flip: {
												enabled: false,
											},
										}}
									>
										{({ TransitionProps }) => (
											<Grow {...TransitionProps}>
												<ClickAwayListener onClickAway={handleClose}>
													<Paper>
														<Box className='list-filter-wrap'>
															<Box className='list-filter-wrap-inner'>
																{TeamReviewFilterList &&
																	TeamReviewFilterList.length > 0 &&
																	TeamReviewFilterList?.map((category: any) => (
																		<>
																			<Box className='task-priority-filter'>
																				<Typography variant='body2'>{category.categoryName}</Typography>
																				<List>
																					{category.subCategories.map((subCategory: any, index: number) => {
																						return (
																							<ListItem key={`type-filter-date-list-${subCategory.subCategoryId}`}>
																								<FormControlLabel
																									control={
																										<Checkbox
																											icon={<BorderCheckboxIcon />}
																											checkedIcon={<CheckedIcon />}
																											checked={
																												localFilterCondition &&
																												localFilterCondition.includes(subCategory.subCategoryId)
																											}
																											value={subCategory.subCategoryId}
																											onChange={() => {
																												handleFilterChanged(subCategory.subCategoryId);
																											}}
																											color='primary'
																										/>
																									}
																									label={subCategory.subCategoryName}
																								/>
																							</ListItem>
																						);
																					})}
																				</List>
																			</Box>
																		</>
																	))}
															</Box>
															<Box className='filter-list-actions'>
																<OKRButton
																	className='apply-btn btn-primary'
																	text={t('applyLabel')}
																	handleClick={(e: any) => {
																		handleClose(e);
																		handleApplyFilterClick(localFilterCondition);
																	}}
																/>
															</Box>
														</Box>
													</Paper>
												</ClickAwayListener>
											</Grow>
										)}
									</Popper>
								</Box>

								<Box className='user-search'>
									<TextField
										className='search-text-field'
										id='user-src-field'
										placeholder={t('searchNameOrTeam')}
										fullWidth
										value={searchValue}
										onChange={(e) => handleSearchChange(e)}
										onKeyDown={(e) => searchClicked(e)}
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<SearchIcon />
												</InputAdornment>
											),
										}}
									/>
									{searchTextArray && (
										<Box className='user-search-chip'>
											<List>
												<ListItem>
													{searchTextArray.length > 20 ? (
														<Tooltip title={searchTextArray} arrow>
															<Chip
																label={searchTextArray.substring(0, 20) + '...'}
																onDelete={clearSearch}
																deleteIcon={
																	<span>
																		<CrossIcon />
																	</span>
																}
															/>
														</Tooltip>
													) : (
														<Chip
															label={searchTextArray}
															onDelete={clearSearch}
															deleteIcon={
																<span>
																	<CrossIcon />
																</span>
															}
														/>
													)}
												</ListItem>
											</List>
										</Box>
									)}
								</Box>
							</Box>
						</Box>
						<TableContainer className='team-review-table-listing'>
							{teamReviewUserList && teamReviewUserList?.length > 0 ? (
								<Table>
									<TableHead>
										<TableRow>
											<TableCell align='center' id={`team-review-col-1`} className='user-col1'>
												<Box className='cell-wrap'>
													{fromApproval && (
														<FormControlLabel
															control={
																<Checkbox
																	icon={<BorderCheckboxIcon />}
																	checkedIcon={<CheckedIcon />}
																	indeterminateIcon={<UnCheckedIcon />}
																	name='selectAll'
																	checked={isSelectAllPages && excludedIds.size === 0}
																	indeterminate={
																		isSelectAllPages
																			? excludedIds.size > 0 && excludedIds.size < totalCount
																			: handleIndeterminate()
																	}
																	onChange={(e: any) => onSelectAllClick(e)}
																/>
															}
															label=''
														/>
													)}
													<Typography
														onClick={(e) => sortList(e, 'firstName')}
														variant='body2'
														className={
															sortingData.column === 'firstName' ? `sort-title ${sortingData.order}` : 'sort-title asc'
														}
														id={'name'}
													>
														<span className='sortable-label'>
															<span className='txt-wrap'>{t('nameLabel')}</span> <SortingIcon />
														</span>
													</Typography>
												</Box>
											</TableCell>
											<TableCell align='center' id={`team-review-col-2`} className='user-col2'>
												<Box className='cell-wrap'>
													<Typography
														variant='body2'
														onClick={(e) => sortList(e, 'teamName')}
														className={
															sortingData.column === 'teamName' ? `sort-title ${sortingData.order}` : 'sort-title asc'
														}
														id={'team'}
													>
														<span className='sortable-label'>
															<span className='txt-wrap'>{t('teamLabel')}</span> <SortingIcon />
														</span>
													</Typography>
												</Box>
											</TableCell>
											<TableCell align='center' id={`team-review-col-3`} className='user-col3'>
												<Box className='cell-wrap'>
													<Typography
														variant='body2'
														onClick={(e) => sortList(e, 'selfReviewStatus')}
														className={
															sortingData.column === 'selfReviewStatus'
																? `sort-title ${sortingData.order}`
																: 'sort-title asc'
														}
														id={'self-review'}
													>
														<span className='sortable-label'>
															<span className='txt-wrap'>{t('selfReviewLevel')}</span> <SortingIcon />
														</span>
													</Typography>
												</Box>
											</TableCell>
											<TableCell align='center' id={`team-review-col-4`} className='user-col4'>
												<Box className='cell-wrap'>
													<Typography
														variant='body2'
														onClick={(e) => sortList(e, 'managerReviewStatus')}
														className={
															sortingData.column === 'managerReviewStatus'
																? `sort-title ${sortingData.order}`
																: 'sort-title asc'
														}
														id={'manager-review'}
													>
														<span className='sortable-label'>
															<span className='txt-wrap'>{t('managerSkipReviewLevel')}</span> <SortingIcon />
														</span>
													</Typography>
												</Box>
											</TableCell>
											<TableCell align='center' id={`team-review-col-5`} className='user-col5'>
												<Box className='cell-wrap'>
													<Typography
														variant='body2'
														onClick={(e) => sortList(e, 'statusName')}
														className={
															sortingData.column === 'statusName' ? `sort-title ${sortingData.order}` : 'sort-title asc'
														}
														id={'review-status'}
													>
														<span className='sortable-label'>
															<span className='txt-wrap'>{t('reviewStatusLabel')}</span> <SortingIcon />
														</span>
													</Typography>
													<OKRButton
														className='info-icon-btn'
														id={'my-team-prg-tooltip'}
														icon={<ReportsTooltipIcon />}
														handleClick={handleReviewApprovalOpen}
													/>
													<Popper
														className={`review-status-info-tooltip`}
														open={openReviewApproval}
														anchorEl={anchorElReviewApproval}
														transition
														placement={'bottom-start'}
													>
														<ClickAwayListener onClickAway={handleReviewApprovalClose}>
															<Box className='textarea-expand'>
																<Typography variant='body2'>{t('reviewApprovalsSequence')}</Typography>
																<Box className='review-approval-sequence-list '>
																	{reviewWorkFlowApprovalList &&
																		reviewWorkFlowApprovalList.length &&
																		reviewWorkFlowApprovalList.map((item: any, index: any) => (
																			<Box className='review-approval-sequence'>
																				<Typography className='review-approval-sequence-index'>
																					{item.workFlowName}
																				</Typography>
																			</Box>
																		))}
																</Box>
																<Box className='review-approval-sequence-content'>
																	<Typography variant='body2' className='font-weight-normal'>
																		{t('reviewApprovalsSequenceLineOne')}
																	</Typography>
																	<Typography variant='body2' className='font-weight-normal'>
																		{t('reviewApprovalsSequenceLineTwo')}
																	</Typography>
																</Box>
															</Box>
														</ClickAwayListener>
													</Popper>
													{/* <HeaderTooltip
														infoTooltipClass='review-status-info-tooltip'
														tooltipText={
															<Box className='review-approvals-seq'>
																<Typography variant='body2'>Review Approvals Sequence</Typography>
															</Box>
														}
														btnId={'my-team-prg-tooltip'}
													/> */}
												</Box>
											</TableCell>
											<TableCell align='center' id={`team-review-col-6`} className='user-col6'></TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{teamReviewUserList &&
											teamReviewUserList
											.map((users: any, index: any) => (

													<TeamReviewData
													key={users.employeeId || `user-${index}`}
														{...props}
														users={users}
														teamReviewUserListResponse={teamReviewUserListResponse}
														t={t}
														index={page * rowsPerPage + index}
														onUserSelect={onUserSelect}
														fromApproval={fromApproval}
														allowOnlyWorkflowId={allowOnlyWorkflowId}
														handleSettingsDrawerOpen={handleSettingsDrawerOpen}
													/>
												
											))}
									</TableBody>
								</Table>
							) : (
								<>
									<NoRecord
										noRecordMessage={t('teamReviewBlankUserListTitle')}
										subHead={t('teamReviewBlankUserListSubTitle')}
										noDataImgWidth={'516'}
										noImg={NoDataImg}
										{...props}
									/>
								</>
							)}
						</TableContainer>

						{showBulkOption && (
							<Box className='bulk-user-edit-bar bulk-user-edit-bar-type1'>
								<Box className='bulk-user-selected'>
									<Typography variant='body1'>
										<TickIcon />
										{checkedUser > 0 ? `${checkedUser} ${t('selectedLabel')}` : '0 selected'}
									</Typography>
								</Box>
								<Box className='bulk-user-action'>
									<List component='ul' disablePadding>
										<ListItem>
											<OKRButton
												icon={<AcceptIcon />}
												title={t('approveLabelandPublishLabel')}
												disabled={checkedUser === 0}
												handleClick={() => {
													if (checkedUser > 0) {
													setModalProps({
														open: true,
														type: 'approve',
														message: t('bulkHrApprove'),
														details: '',
													});
												}
												}}
												className='action-btn'
											></OKRButton>
										</ListItem>
										<ListItem>
											<OKRButton
												icon={<ReconsiderIcon />}
												title={t('sendBackForReconsideration')}
												tooltipClassName='tooltip-layout-auto'
												disabled={checkedUser === 0}
												handleClick={(e) => {
													if (checkedUser > 0) {
													setModalProps({
														open: true,
														type: 'reconsider',
														message: t('bulkBuReconsider'),
														details: '',
													});
												}
												}}
												className='action-btn'
											></OKRButton>
										</ListItem>
									</List>
								</Box>
							</Box>
						)}
					</Box>
				</>
			)}
			{modalProps && modalProps.open && (
				<AlertDialog
					module='PerformanceReviewList'
					isCancel={false}
					message={modalProps?.message || ''}
					handleCloseModal={handleCloseModal}
					modalOpen={modalProps.open}
				/>
			)}
			{categorySettingsOpen.open && (
				<ReviewConversationsSettings
					{...props}
					t={t}
					categorySettingsOpen={categorySettingsOpen}
					handleSettingsDrawerClose={handleSettingsDrawerClose}
					selectTab={currentTab}
					teamReviewUserListResponse={teamReviewUserListResponse}
				/>
			)}
		</>
	);
};
